import { Col, Row } from 'react-bootstrap';
import { ValueType, type SectionField } from '../AdditionalSection/types';
import { ProfileField } from '../ProfileField';
import { Edit } from '../../../Icons';
import CareMapprIconButton from '../../../Button/CareMapprIconButton';
import { usePatientProfile } from '../../hooks';
import React from 'react';
import EpisodeDetailActionButtons from '../AdditionalSection/EpisodeDetailActionButtons';
import DataMapperProfileBar from '../../../DataMapper/DataMapperProfileBar';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../../store';
import { useLocation } from 'react-router-dom';

interface CollapsedDetailsProps {
  collapsedConfig: SectionField[];
  clinics: any[];
  handleInputChange: (
    e: any,
    clinicIndex?: number,
    episodeIndex?: number,
  ) => void;
  patientProfileStatus: boolean;
}
const CollapsedDetails = ({
  collapsedConfig,
  clinics,
  handleInputChange,
  patientProfileStatus,
}: CollapsedDetailsProps) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const patientAccessToken = searchParams.get('access_token');
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const [currentEditingField, setCurrentEditingField] = React.useState<
    string[]
  >([]);
  const {
    editProfile,
    patientProfile,
    actionBarGroup,
    onToggleClinics,
    openClinics,
    setOpenClinics,
    onSubmit,
    form,
  } = usePatientProfile();

  const { showEditButton: actionBarHasEditButton } = actionBarGroup;

  const onEditClick = (e: React.MouseEvent, fieldKey: string) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentEditingField((pre) => [...pre, fieldKey]);
  };

  const onCancelClick = (fieldKey: string, e?: React.MouseEvent) => {
    e?.preventDefault();
    e?.stopPropagation();
    setCurrentEditingField((pre) => pre.filter((item) => item !== fieldKey));
  };

  const onDoneClick = (fieldKey: string, e?: React.MouseEvent) => {
    if (!selectedTenancy || !patientAccessToken) return;
    e?.preventDefault();
    e?.stopPropagation();
    setCurrentEditingField((pre) => pre.filter((item) => item !== fieldKey));
    const formData = DataMapperProfileBar(
      form.formState,
      patientProfile,
      patientAccessToken,
      selectedTenancy,
      [],
    );
    onSubmit(formData);
  };

  const dataReady = patientProfileStatus;
  return (
    <Row gap={2}>
      {dataReady &&
        collapsedConfig &&
        collapsedConfig.map((field: SectionField, index) => {
          const keys = field.key.split('.');
          const fieldKey = `${field.key}-${index}-collapsed-details`;
          const isSelfManagedEpisodeOptions =
            field.formatType === 'episode_detail' &&
            field.editType === ValueType.OPTIONS;
          const isEditing =
            currentEditingField.includes(fieldKey) || editProfile;
          return (
            <Col
              sm="4"
              key={`collapsed-details-${field.key}-${index}`}
              className="d-flex align-items-start gap-1 min-height-29"
            >
              <ProfileField
                dataKey={keys[1]}
                field={field}
                value={patientProfile}
                editProfile={isEditing}
                onInputChange={handleInputChange}
                onToggleClinics={onToggleClinics}
                openClinics={openClinics}
                setOpenClinics={setOpenClinics}
                patientProfileStatus={patientProfileStatus}
                clinic={patientProfile.clinics?.[0]}
                healthProfessionals={
                  clinics.find(
                    (x) => x.clinic_id === patientProfile.clinics?.[0]?.id,
                  )?.healthProfessionals ?? []
                }
              />
              {!isEditing &&
                !actionBarHasEditButton &&
                field.editable &&
                !isSelfManagedEpisodeOptions && (
                  <CareMapprIconButton
                    className="m-0 p-0 min-width-auto"
                    icon={<Edit size={14} />}
                    onClick={(e) => {
                      onEditClick(e, fieldKey);
                    }}
                  />
                )}
              {!editProfile && isEditing && !isSelfManagedEpisodeOptions && (
                <EpisodeDetailActionButtons
                  buttonClassName="m-0 p-0"
                  onConfirm={(e) => onDoneClick(fieldKey, e)}
                  onCancel={(e) => onCancelClick(fieldKey, e)}
                />
              )}
            </Col>
          );
        })}
    </Row>
  );
};

export default CollapsedDetails;
